<template>
    <div>
        <Navbar />
        <BuyNow />
        <PageTitle pageTitle="Etkinliklerimiz" />
        <CoursesList pathUrl="https://dryyazilim.com.tr/anaokulu/assets/data/get.php" />
        <Footer />
    </div>
</template>

<script>
import Navbar from '../Layouts/Navbar'
import PageTitle from '../Common/PageTitle'
import CoursesList from '../CoursesFive/CoursesList'
import Footer from '../Layouts/Footer'
import BuyNow from '../Layouts/BuyNow'

export default {
    name: 'CoursesPageFive',
    components: {
    Navbar,
    PageTitle,
    CoursesList,
    Footer,
    BuyNow
},
}
</script>